// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"J4-z","dimensionLabel":"K4-z","styleChooserControlWrapper":"L4-z","styleChooserControl":"M4-z","disabled":"N4-z","giftCard":"O4-z","styleChooserText":"P4-z"};